import React, { useState } from 'react';
import { signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { Button, Typography, Box, Grid, Paper, TextField } from '@mui/material'; // Import TextField
import GoogleIcon from '@mui/icons-material/Google';
import { useNavigate } from 'react-router-dom'; // React Router's useNavigate hook
import '../App.css';

const Login = () => {
    const [error, setError] = useState(null);
    const firestore = getFirestore();
    const googleProvider = new GoogleAuthProvider();
    const navigate = useNavigate(); // React Router navigation
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleGoogleSignIn = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;

            // Fetch user data from Firestore based on UID
            const userDocRef = doc(firestore, 'users', user.uid);
            const userDoc = await getDoc(userDocRef);

            if (userDoc.exists()) {
                const userData = userDoc.data();

                // Print the assignedDataset, email, and uid
                console.log('Assigned Dataset:', userData.assignedDataset || 'No dataset assigned');
                console.log('Email:', user.email);
                console.log('UID:', user.uid);

                // Navigate to the map page without passing dataset in the URL
                navigate(`/`);
            } else {
                setError('User not found in the system.');
                console.error('User document not found in Firestore');
            }
        } catch (error) {
            setError('Failed to sign in with Google, contact Ricky or Christian for help.');
            console.error(error);
        }
    };

    const handleEmailPasswordSignIn = async (e) => {
        e.preventDefault(); // Prevent form submission

        try {
            const result = await signInWithEmailAndPassword(auth, email, password);
            const user = result.user;

            // Fetch user data from Firestore based on UID
            const userDocRef = doc(firestore, 'users', user.uid);
            const userDoc = await getDoc(userDocRef);

            if (userDoc.exists()) {
                const userData = userDoc.data();

                // Print the assignedDataset, email, and uid
                console.log('Assigned Dataset:', userData.assignedDataset || 'No dataset assigned');
                console.log('Email:', user.email);
                console.log('UID:', user.uid);

                // Navigate to the map page
                navigate(`/`);
            } else {
                setError('User not found in the system.');
                console.error('User document not found in Firestore');
            }
        } catch (error) {
            setError('Failed to sign in with email and password.');
            console.error(error);
        }
    };

    return (
        <Grid container justifyContent="center" alignItems="center" className="login-container">
            <Grid item xs={12} sm={8} md={5}>
                <Paper elevation={3} className="login-paper">
                    <Box
                        component="form"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 3,
                            p: 4,
                            maxWidth: '400px',
                            margin: 'auto',
                        }}
                        onSubmit={handleEmailPasswordSignIn} // Handle form submission
                    >
                        <Typography variant="h4" component="h1" align="center">
                            DE Markers
                        </Typography>
                        <Typography variant="body1" component="p" align="center">
                            <strong>Sign In Required to access the map.</strong>
                            <br />
                            <br />
                            Contact Ricky or Christian for access.
                        </Typography>

                        {error && (
                            <Typography variant="body2" color="error" align="center">
                                {error}
                            </Typography>
                        )}

                        {/* Email Input */}
                        <TextField
                            type="email"
                            label="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            variant="outlined"
                            fullWidth
                            required
                        />

                        {/* Password Input */}
                        <TextField
                            type="password"
                            label="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            variant="outlined"
                            fullWidth
                            required
                        />

                        <Button type="submit" variant="contained" color="primary" fullWidth>
                            Login with Email
                        </Button>

                        <Button
                            onClick={handleGoogleSignIn}
                            variant="outlined"
                            color="primary"
                            startIcon={<GoogleIcon />}
                            fullWidth
                        >
                            Login with Google
                        </Button>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default Login;
